import React from "react";
import {
  InlineCTABase,
  ImageBasic,
  Copy,
  StyledCTA,
} from "./inline-cta.styled";
import { InlineCtaSliceFragment } from "../../types/graphql";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IInlineCTAProps = Slice<
  SharedSliceType,
  InlineCtaSliceFragment["primary"]
> & { type: SharedSliceType.inline_cta };

const InlineCTA = ({
  slice,
  context,
}: SliceComponentProps<IInlineCTAProps, IPageContext>) => {
  const inlineCTA = slice.primary;
  return (
    (inlineCTA && (
      <InlineCTABase>
        {inlineCTA.image?.url && (
          <ImageBasic
            src={inlineCTA?.image.url}
            alt={inlineCTA?.image?.alt || "Xometry Image"}
          />
        )}
        {inlineCTA.copy && <Copy>{inlineCTA?.copy}</Copy>}
        {(inlineCTA.cta_link1?.url || inlineCTA.drift_bot_interaction_id) &&
          inlineCTA.cta_text1 && (
            <StyledCTA
              kind="primary"
              scale="xlarge"
              pageSection="inline-cta"
              ctaText={inlineCTA.cta_text1}
              action={inlineCTA.cta_action}
              linkURL={inlineCTA.cta_link1?.url}
              target={inlineCTA.cta_link1?.target}
              driftBotInteractionID={inlineCTA.drift_bot_interaction_id}
            />
          )}
      </InlineCTABase>
    )) || <></>
  );
};

export default InlineCTA;
